import Layout from '../../internal/ScheduleLayout.vue'
import SchedulePage from './schedule.vue'

const ScheduleRoutes = {
  component: Layout,
  children: [
    {
      name: 'schedule',
      path: '/',
      component: SchedulePage,
      meta: {
        requiresAuth: true,
        requiresMaster: true,
        requiresAdmin: true,
        requiresSupervisor: true,
        requiresOperator: true,
        requiresCoordOp: true,
        requiresCoordSector: true,
        requiresLaboratory: true,
      },
    },
  ],
}

export default ScheduleRoutes
